import React from "react";
import * as Icons from "lucide-react";
import { Check } from "lucide-react";
import { PILLARS, FOR_YOU, FOR_PRACTITIONERS, FIT_LIST } from "../mock";
import { useReveal } from "../hooks/useReveal";

function Pillar({ p, i }) {
  const ref = useReveal();
  const Icon = Icons[p.icon] || Icons.Sparkles;
  return (
    <div
      ref={ref}
      className={`reveal reveal-delay-${(i % 4) + 1} glass card-lift rounded-2xl p-6 text-center`}
    >
      <div className="mx-auto mb-4 w-12 h-12 rounded-xl bg-gradient-to-br from-[#1f6f8b]/40 to-[#5a5ee0]/30 flex items-center justify-center ring-1 ring-white/10">
        <Icon className="w-6 h-6 text-[#7fd8e8]" />
      </div>
      <div className="eyebrow text-[#f6e3a8] text-[11px] mb-2">{p.tag}</div>
      <p className="text-sm text-white/70 leading-relaxed">{p.text}</p>
    </div>
  );
}

function ColList({ title, items, accent }) {
  const ref = useReveal();
  return (
    <div ref={ref} className="reveal glass rounded-2xl p-7">
      <h4 className="text-2xl mb-5" style={{ color: accent }}>{title}</h4>
      <ul className="space-y-3">
        {items.map((it) => (
          <li key={it} className="flex items-start gap-3 text-white/80">
            <span
              className="mt-1 w-5 h-5 rounded-full flex items-center justify-center shrink-0"
              style={{ background: `${accent}22` }}
            >
              <Check className="w-3 h-3" style={{ color: accent }} />
            </span>
            <span className="text-[15px]">{it}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default function Transformation() {
  const head = useReveal();
  const fit = useReveal();
  return (
    <section id="portail" className="relative py-24 md:py-28">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div ref={head} className="reveal text-center max-w-3xl mx-auto">
          <p className="eyebrow text-[#7fd8e8] text-xs mb-4">Un portail de transformation</p>
          <h2 className="text-4xl md:text-5xl text-white leading-tight">
            Un portail pour changer de timeline <span className="text-gold">et te déployer</span>
          </h2>
          <p className="mt-5 text-white/70 text-lg">
            Un voyage d'expansion de conscience pour retrouver une vie remplie d'amour, de joie et de légèreté !
          </p>
          <p className="mt-8 text-sm eyebrow text-white/50">Active la sagesse des Maîtres Dauphins pour :</p>
        </div>

        <div className="mt-10 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-5">
          {PILLARS.map((p, i) => (
            <Pillar key={p.tag} p={p} i={i} />
          ))}
        </div>

        <div className="mt-16 grid md:grid-cols-2 gap-6">
          <ColList title="Pour Toi" items={FOR_YOU} accent="#f6e3a8" />
          <ColList title="Pour les Praticiens" items={FOR_PRACTITIONERS} accent="#7fd8e8" />
        </div>

        <div ref={fit} className="reveal mt-16 glass rounded-3xl p-8 md:p-12 relative overflow-hidden">
          <div className="absolute -top-24 -right-24 w-72 h-72 rounded-full bg-[#5a5ee0]/15 blur-3xl" />
          <p className="text-white/70 text-lg max-w-3xl">
            Tu as tout pour être heureux(se) sur le papier… mais ça ne vibre pas autant que prévu.
            Ici, on ne te sert pas des concepts prémâchés. On est sur du <em className="text-gold not-italic font-semibold">high level</em> : précis, profond, incarné. Une forme de haute couture intérieure.
          </p>
          <h3 className="mt-9 text-2xl md:text-3xl text-white">Cette École est pour toi si :</h3>
          <ul className="mt-6 grid md:grid-cols-2 gap-x-10 gap-y-4">
            {FIT_LIST.map((f) => (
              <li key={f} className="flex items-start gap-3">
                <Check className="w-5 h-5 text-[#7fd8e8] shrink-0 mt-0.5" />
                <span className="text-white/80">{f}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
